import logo from './logo.svg';
import React from 'react';
import './App.css';
import Home from './Home.js';
import Rift from './Rift';
import Transmission from './Transmission';
import Map from './Map';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function App() {
  return (
    <Router >
    
      <Switch>
         
      <Route path="/map">
            <Map />
      </Route>


      <Route path="/transmission">
            <Transmission />
      </Route>

      <Route path="/rift">
            <Rift />
      </Route>

      <Route path="/">
            <Home />
      </Route>
          
      </Switch>
  
    </Router>
  );
}

export default App;
